/**
 * 设置菜单索引
 * */
import localStorageProxy from "./listenToStorage";
import {getTree} from "./menuAuth";

const first = 'platform_first';
const second = 'platform_second';

// 获取一级菜单索引
export function getFirst() {
  return window.localStorage.getItem(first)
}

// 设置一级菜单索引
export function setFirst(index) {
  // window.localStorage.setItem(first, index)
  return localStorageProxy[first] = index
}

// 获取二级菜单索引
export function getSecond() {
  return window.localStorage.getItem(second)
}

// 设置二级菜单索引
export function setSecond(index) {
  // window.localStorage.setItem(second, index)
  localStorageProxy[second] = index
}

// 设置当前key
export function getWebIndex(key){
  let data = '';
  let option = getTree()?JSON.parse(getTree()):[];
  try{
    option.forEach((item,i)=>{
      if (item.childList&&item.childList.length>0){
        item.childList.forEach((child,c)=>{
          if (child.uniqueCode == key){
            setFirst(i);
            setSecond(c);
            data = {first:i, second:c}
            throw new Error('finish')
          }
        })
      } else {
        if (item.uniqueCode === key) {
          setFirst(i);
          data = {first: i, second:''}
        }
      }
    })
  }catch(e){
    if(e.message!=='finish'){
      console.log(e.message)
    }
  }
  return data
}



// WEBPACK FOOTER //
// ./src/utils/menuIndex.js